import { List } from 'components/ui';
import ListItem from 'components/space/order/index/list_item';
import ListHeader from 'components/space/order/index/list_header';
import Loader from 'components/loader';

const Index = ({ orders, loading }) => {
  if (loading) return <Loader />;

  return (
    <List>
      <ListHeader visible={orders.length > 0} />
      {orders.map((order) => (
        <ListItem key={order.id} order={order} />
      ))}
    </List>
  );
};

export default Index;
